import React from "react";
import { StartDateDenied } from "./start-date-denied";
import { TasksReminder } from "./tasks-reminder";
import { BannerType, IndiaBannerSelector } from "./india-banner-selector";
import { ScreeningResultsProgressControlled } from "../appointment-card/screening-result-progress";
import { useGetJobDetails } from "../../hooks/apis/useGetJobDetails";
import { StartDateDetails } from "./start-date-details";

/**
 * Props for the IndiaHiringBanner component
 */
interface IndiaHiringBannerProps {
  applicationState?: string;
  // startDate related
  startDate?: string;
  startDateStatus?: string;
}

/**
 * India Agency Hiring specific banner component
 * Displays appropriate banners based on application state and various conditions
 * According to IAH design requirements:
 * - Shows PHO completion reminder when PHO is pending
 * - Shows background check status banners during contingencies phase
 * - Shows start date information or issues during later phases
 * - Provides a generic task reminder when no specific condition matches
 */
export function IndiaHiringBanner(props: IndiaHiringBannerProps) {
  // Use the selector to determine which banner to show
  const bannerType = IndiaBannerSelector.determineBannerType(props);
  const jobDetails = useGetJobDetails();

  // Render the appropriate banner based on the determined type
  switch (bannerType) {
    case BannerType.SCREENING:
      return <ScreeningResultsProgressControlled jobDetails={jobDetails} />;

    case BannerType.START_DATE_DENIED:
      return <StartDateDenied />;

    case BannerType.TASK_REMINDER_WITH_DATE:
      return <TasksReminder startDate={props.startDate} />;

    case BannerType.START_DATE_DETAILS:
      return <StartDateDetails jobDetails={jobDetails} />;

    // if new bannerType is added, add a case here
  }
}

/* Export all banner components for direct usage if needed */

/* eslint-disable import/no-unused-modules */
export { BackgroundCheckError } from "./background-check-error";
export { BackgroundCheckProcess } from "./background-check-process";
export { StartDateDenied } from "./start-date-denied";
export { TasksReminder } from "./tasks-reminder";
export { StatusBanner } from "./status-banner";
export { BannerType, IndiaBannerSelector } from "./india-banner-selector";
/* eslint-enable import/no-unused-modules */
